import actions from 'actions/jobs'
import fileTemplateActions from 'actions/fileTemplates'
import operatorActions from 'actions/operators'
import userActions from 'actions/users'
import locationActions from 'actions/locations'
import assetCategoryActions from 'actions/assetCategories'
import assetActions from 'actions/assets'
import jobReasonActions from 'actions/jobReasons'
import jobStatusOptionActions from 'actions/jobStatusOptions'
import jobGroupActions from 'actions/jobGroups'
import jobChecklistActions from 'actions/jobs/jobChecklist'
import jobLabourActions from 'actions/jobs/jobLabour'
import assetWarrantyActions from 'actions/assets/assetWarranties'
import assetToleranceActions from 'actions/assets/assetTolerances'
import documentActions from 'actions/documents'
import {
  createChildItemsDispatchToProps,
  createDocumentsDispatchToProps,
  createLinkedItemsDispatchToProps,
} from 'helpers/formViews'
import { createFormViewContainer } from 'factories/FormView'
import formInstanceActions from 'actions/formInstances'
import Component from 'components/Jobs/FormView'

export default createFormViewContainer({
  actions,
  extraDispatchToProps: (dispatch, props) => ({
    newItem: (params) => dispatch(actions.newItem(params)),
    generateId: (params) => dispatch(actions.generateId(params)),
    getLocations: (params) =>
      dispatch(locationActions.getItems({ ...params, locationVendingTypes: ['NonVending'] })),
    getAssetCategories: (params) => dispatch(assetCategoryActions.getOptions(params)),
    getJobReasons: (params) => dispatch(jobReasonActions.getOptions(params)),
    getJobGroups: (params) => dispatch(jobGroupActions.getOptions(params)),
    getJobStatusOptions: (params) => dispatch(jobStatusOptionActions.getOptions(params)),
    getAssets: (params) =>
      dispatch(
        assetActions.getOptions({
          pageIndex: 1,
          pageSize: 100,
          ...params,
        })
      ),
    getUsers: (params) => dispatch(userActions.getItems(params)),
    getOperators: (params) =>
      dispatch(
        operatorActions.getOptions({
          pageIndex: 1,
          pageSize: 100,
          ...params,
          active: 'Active',
        })
      ),
    getFileTemplates: (params) => dispatch(fileTemplateActions.getOptions(params)),
    getFileTemplate: (fileTemplateId) => dispatch(fileTemplateActions.getItem(fileTemplateId)),
    requestApprovalToBegin: (id) => dispatch(actions.requestApprovalToBegin(id)),
    requestApprovalToClose: (id) => dispatch(actions.requestApprovalToClose(id)),
    createFromTemplate: (id, params) => dispatch(actions.createFromTemplate(id, params)),
    emailJob: (id, params) => dispatch(actions.emailJob(id, params)),
    createTolerancesHistoryItems: (parentId, items) =>
      dispatch(assetToleranceActions.createHistoryItems(parentId, items)),
    ...createDocumentsDispatchToProps(dispatch, documentActions),
    ...createChildItemsDispatchToProps(dispatch, 'Checklist', jobChecklistActions),
    ...createChildItemsDispatchToProps(dispatch, 'Labour', jobLabourActions),
    ...createChildItemsDispatchToProps(dispatch, 'Warranty', assetWarrantyActions),
    ...createChildItemsDispatchToProps(dispatch, 'Tolerance', assetToleranceActions),
    ...createLinkedItemsDispatchToProps(dispatch, 'FormInstance', formInstanceActions),
  }),
})(Component)
